import React from 'react';
import { StyledNotification } from './notification.styles';
import { StyledVisuallyHiddenContainer } from '@at/design-system-foundation';
export var Notification = function (_a) {
    var data = _a.data, name = _a.name, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.hideCount, hideCount = _c === void 0 ? false : _c;
    var returnItem = data ? Object.values(data).filter(function (item) { return item.title === name; }) : null;
    if (returnItem && returnItem[0] && returnItem[0].total > 0) {
        return (React.createElement(StyledNotification, { small: hideCount, className: className },
            hideCount && (React.createElement(StyledVisuallyHiddenContainer, { as: "span" }, returnItem[0].total)),
            !hideCount && returnItem[0].total));
    }
    return null;
};
